import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { parse, format, AsYouType } from 'libphonenumber-js';
import {ActivatedRoute} from '@angular/router';
import {Constants} from '../constants';
import {EventsService} from 'angular4-events';

declare var $: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-account-statement',
  templateUrl: './account-statement.component.html',
  styleUrls: ['./account-statement.component.css']
})
export class AccountStatementComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  nao = new Nanobar();
  id: number;
  private sub: any;
  statementData: any;
  statementTotalPaid: any;
  statementTotalBill: any;
  printPopOpen = false;
  businessName = '';
  invoiceData: any;
  invoiceDetailData: any;
  invoiceDetailDatainner: any;
  invoiceDetailDataOrder: any;
  address: any;
  idvas: any;
  previousData: any;
  statementPageCount = 0;
  paginatedDataStatement: any;
  statementLastPage: any;
  constructor(private dataService: DataService, private route: ActivatedRoute, private events: EventsService) {
    this.dataService.pageName = 'outlet statement';
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id']; // (+) converts string 'id' to a number
      console.log('this.id', this.id);
    });
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
    this.idvas = this.events.subscribe('accountsId').subscribe((data) => {
      this.id = data.id;
      this.previousData = data;
      this.getbusinessStatement();
    });
  }

  getbusinessStatement() {
    this.nao.go(30);
    this.dataService.getAccountStatement(window.localStorage.getItem('token'), this.id).subscribe(
      (data) => {
        this.nao.go(100);
        this.statementData = data;
        this.statementLastPage = this.statementData.last_page;
        this.businessName = this.statementData.business_name;
        this.statementTotalBill = this.statementData.total_bill;
        this.statementTotalPaid = this.statementData.total_paid;
        this.statementData = this.statementData.items;
        this.statementPageCount = 0;
        console.log('statementData', this.statementLastPage);
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }

  getStatementByPageFunction() {
    this.nao.go(30);
    this.statementPageCount++;
    console.log('login data');
    this.dataService.getStatementByPage(window.localStorage.getItem('token'), this.statementPageCount, this.id).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataStatement = data;
        this.statementLastPage = this.paginatedDataStatement.last_page;
        this.statementTotalBill = this.statementTotalBill + this.paginatedDataStatement.total_bill;
        this.statementTotalPaid = this.statementTotalPaid + this.paginatedDataStatement.total_bill;
        // this.limit = this.paginatedData.limit;
        this.paginatedDataStatement = this.paginatedDataStatement.items;
        for (var i = 0; i < this.paginatedDataStatement.length; i++) {
          this.statementData.push(this.paginatedDataStatement[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

  openprintStatementPop() {
    var context = this;
    let printContents, popupWin;
    context.printPopOpen = true;
    // const configuracion_ventana = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
    // 'height=400,width=800'
    setTimeout(() => {
      printContents = document.getElementById('statementPrint');
      // var oldPage = document.body.innerHTML;
      popupWin = window.open('package pdrop_pinop', '', 'height=400,width=800');
      popupWin.document.open();
      popupWin.document.write('<html><body onload="window.print()">' + printContents.innerHTML + '</body></html>');
      popupWin.document.close();
      // popupWin.close();
      // context.printPopOpen = false;
    }, 1000);
    setTimeout(function() {
      popupWin.close();
      context.printPopOpen = false;
    }, 1500);
  }
  invoiceDetail(id) {
    this.nao.go(30);
    this.dataService.getInvoiceDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.invoiceDetailData = data;
        this.invoiceDetailData = this.invoiceDetailData.invoice_detail;
        this.address = this.invoiceDetailData.address;
        this.invoiceDetailDatainner = this.invoiceDetailData.invoice_detail;
        console.log('this.invoiceDetailDatainner', this.invoiceDetailDatainner);
        this.invoiceDetailDataOrder = this.invoiceDetailDatainner.order_list;
        $('#invoicePop').modal('show');
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }
  goBackToDespensaryListing(){
    var data = {'id': this.id, 'page': this.previousData.page, 'scroll': this.previousData.scroll};
    this.events.publish('detail', data);  }
  ngOnInit() {
    // this.getbusinessStatement();
  }

}



// WEBPACK FOOTER //
// ./src/app/account-statement/account-statement.component.ts